<template>
  <div class="weekly_svg" ref="svg">
    <svg
      :viewBox="svgViewWidth"
      :height="svgHeight"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <svg
        v-for="({ steps, yyyymmdd, goal_steps, getstamp }, index) in stepsData"
        :key="index"
        :x="index * weekWidth + margin"
        :width="weekWidth"
        :height="y"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0"
        :viewBox="weekViewWidth"
      >
        <rect
          :x="barX"
          :y="weekBarY(steps)"
          :width="barWidth"
          :height="weekBarHeight(steps)"
          rx="8"
          fill="url(#paint0_linear)"
        />
        <image
          id="image1"
          xlink:href="@/assets/img/walk/tassei.png"
          :width="markWidth"
          :height="markHeight"
          :y="calcHeight(steps)"
          :x="markX"
          v-if="steps >= goal_steps"
        />
        <image
          id="image0"
          xlink:href="@/assets/img/walk/kakutoku.png"
          :width="markWidth"
          :height="markHeightForGet"
          :y="calcHeight(steps)"
          :x="markX"
          v-if="getstamp > 0"
        />
        <text
          x="50%"
          y="470"
          text-anchor="middle"
          dominant-baseline="central"
          fill="#333333"
          font-size="24"
        >
          {{ formatDate(yyyymmdd) }} {{ unit }}
        </text>
        <rect
          class="touchable"
          :x="barX"
          :y="0"
          :width="barWidth"
          :height="y"
          rx="4"
          v-on:touchstart="showTip(steps, index, yyyymmdd, $event)"
          v-on:touchend="hideTip()"
        />
      </svg>
      <Tips
        y="160"
        :display="tipDisplay"
        :text="tipText"
        :steps="tipSteps"
        :unit="unit"
        :center="center"
      />
      <line
        x1="0%"
        y1="450"
        x2="100%"
        y2="450"
        stroke="#CCCCCC"
        stroke-width="8px"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="20.5"
          y1="63"
          x2="20.5"
          y2="451"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F93846" />
          <stop offset="0.5" stop-color="#Fb7d4a" />
          <stop offset="1" stop-color="#FFA666" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>
<script>
import Tips from './WeeklyTips'
import moment from 'moment'
export default {
  name: 'WeeklyBar',
  components: {
    Tips
  },
  data: () => {
    return {
      weekWidth: 110,
      barHeight: 338,
      barTop: 113,
      barWidth: 50,
      markWidth: 74,
      markHeight: 82,
      markHeightForGet: 101,
      margin: 90,
      y: 490,
      tipDisplay: 'none',
      tipText: '',
      tipSteps: 0,
      svgHeight: 0,
      center: 0
    }
  },
  props: {
    stepsData: Array,
    unit: String
  },
  mounted: function() {
    this.svgHeight = this.$refs.svg.clientHeight
  },
  computed: {
    barX: function() {
      return (this.weekWidth - this.barWidth) / 2
    },
    markX: function() {
      return (this.weekWidth - this.markWidth) / 2
    },
    weekViewWidth: function() {
      return `0 0 ${this.weekWidth} ${this.y}`
    },
    svgViewHieght: function() {
      return Math.max(
        this.weekWidth * this.stepsData.length + this.margin * 2,
        700
      )
    },
    svgViewWidth: function() {
      return `0 0 ${this.svgViewHieght} ${this.y}`
    },
    maxSteps: function() {
      // 表示する歩数グラフの最大歩数
      return this.stepsData.length > 0
        ? Math.max(...this.stepsData.map(item => item.steps))
        : 0
    }
  },
  methods: {
    calcHeight: function(steps) {
      const percent =
        steps === 0 ? 0 : (parseFloat(steps) / this.maxSteps) * 100
      return this.barHeight - this.barHeight * percent * 0.01
    },
    weekBarY: function(steps) {
      return this.barTop + this.calcHeight(steps)
    },
    weekBarHeight: function(steps) {
      return this.barHeight - this.calcHeight(steps)
    },
    showTip: function(tipSteps, index, text, event) {
      this.center = index * this.weekWidth + this.margin + this.weekWidth / 2
      this.tipText = `${this.formatDateForTips(text)}の歩数`
      this.tipSteps = tipSteps
      this.tipDisplay = 'block'
    },
    hideTip: function() {
      this.tipDisplay = 'none'
    },
    formatDate: function(yyyymmdd) {
      const format = this.unit === '週' ? 'MM/DD' : 'YY/MM'
      return moment(yyyymmdd).format(format)
    },
    formatDateForTips: function(yyyymmdd) {
      const format = this.unit === '週' ? 'YYYY年MM月DD日 週' : 'YYYY年MM月'
      return moment(yyyymmdd).format(format)
    }
  }
}
</script>

<style scoped lang="scss">
.weekly_svg {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 4px;

  svg {
    pointer-events: none;
    user-select: none;

    .touchable {
      pointer-events: auto;
      user-select: auto;
    }
  }
}
</style>
